<template>
	<page>
		<module :title="id ? '编辑优惠券' : '新建优惠券'">
			<c-form ref="form" unit-width="500">
				<c-title>基础信息</c-title>
				<c-form-item label="优惠券名称" required>
					<c-input name="coupon_name" placeholder="请输入优惠券名称" maxlength="20"></c-input>
				</c-form-item>
				<c-form-item label="优惠方式" required>
					<c-radio-group name="coupon_kinds" v-model="salesType" :options="salesTypeOption" ></c-radio-group>
				</c-form-item>
				<c-form-item>
					<div class="limit flex">
						<div v-show="salesType != 1" class="flex-center-cross item">
							<label>{{salesType == 2 ? '满' : '每满'}}</label>
							<c-input type="number" decimal="2" :range="[1,999999]" v-model="limit" name="activity_notice_time" unit="元" style="width:120px"></c-input>
						</div>
						<div class="flex-center-cross item">
							<label>减</label>
							<c-input type="number" decimal="2" :range="[1,99999]" v-model="sales" name="activity_notice_time" unit="元" style="width:120px"></c-input>
						</div>
					</div>
				</c-form-item>
				<c-form-item label="使用说明">
					<c-input type="textarea" name="coupon_description"></c-input>
				</c-form-item>
				
				<c-title>适用范围</c-title>
				<c-form-item label="使用条件简述" required>
					<c-input name="commodity_remark" maxlength="1000"></c-input>
				</c-form-item>
				<c-form-item label="可用范围" required>
					<c-radio-group name="commodity_range" v-model="commodityRange" :options="commodityRangeOption" ></c-radio-group>
				</c-form-item>
				<c-form-item v-show="commodityRange == 2" width="1000">
					<c-button color="gray" @click="$refs.productSelector.open()">添加商品</c-button>
					
					<c-table ref="productList" :data="productList" :paging="false" border>
						<c-table-column
							label="状态"
							name="state"
							width="100"
						>
							<template v-slot="{data}">
								{{dict.productState[data.state]}}
							</template>
						</c-table-column>
						
						<c-table-column
							label="商品信息"
							name="product_name"
							width="250"
						>
							<template v-slot="{data}">
								<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
								<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
							</template>
						</c-table-column>
						
						<c-table-column
							label="上架时间"
							name="sell_state_date"
							width="150"
						></c-table-column>
						
						<c-table-column
							type="button"
							fixed="right"
							label="操作"
							width="100"
						>
							<template v-slot="row">
								<c-table-button @click="deleteProduct(row.data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
				<c-form-item v-show="commodityRange == 3" width="800">
					<div>
						<c-form ref="attrForm" unit-width="95%" column="2">
							<c-form-item label="商品类目">
								<c-select v-model="classify" name="product_type_id" options="PRODUCT_CLASSIFY" multiple></c-select>
							</c-form-item>
							<c-form-item label="品牌">
								<c-select v-model="brand" name="product_brand_id" value="71,62" options="BRAND_LIST" multiple></c-select>
							</c-form-item>
						</c-form>
					</div>
				</c-form-item>
			</c-form>
			
			<template slot="button">
				<c-button color="main" size="form" @click="submit(1)">确定提交</c-button>
				<c-button size="form" @click="submit(0)">暂存草稿</c-button>
			</template>
		</module>
		
		<product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
	</page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	import productSelector from '@/components/service/product_selector.vue'
	import {mapState} from 'vuex'
	
	export default {
		name: 'coupon_edit',
		
		components: {
			productInfo,productSelector
		},
		
		props: {
			id: String
		},
		
		data() {
			return {
				salesType: 1,
				salesTypeOption: [{
					name: '无门槛券',
					value: 1
				}, {
					name: '满减券',
					value: 2
				}, {
					name: '满减叠加券',
					value: 3
				}],
				
				limit: '',
				sales: '',
				
				commodityRange: 1,
				commodityRangeOption: [{
					name: '全部商品',
					value: 1
				}, {
					name: '指定商品',
					value: 2
				}, {
					name: '指定条件',
					value: 3
				}],
				
				productList: [],
				
				classify: '',
				brand: ''
			}
		},
		
		computed: {
			...mapState(['dict'])
		},
		
		watch: {
			id() {
				this.getCoupontDetail();
			},
			
			commodityRange(val) {
				if (val == 2) {
					this.$refs.productList.resize();
				}
			}
		},
		
		mounted() {
			this.id && this.getCoupontDetail();
		},
		
		methods: {
			getCoupontDetail() {
				this.request({
					url: '/couponInfo/detail',
					data: {
						id: this.id
					},
					loading: true,
					success: data => {
						this.$refs.form.set(data);
						data.coupon_kinds != 1 && (this.limit = data.condition_amount);
						this.sales = data.decrease_amount;
						
						if (data.commodity_range == 2) {
							this.productList = data.product_list || [];
						}
						
						if (data.commodity_range == 3 && data.commodity_condition_json) {
							let range = JSON.parse(data.commodity_condition_json);
							this.classify = range.classify_ids;
							this.brand = range.brand_ids;
						}
					}
				});
			},
			
			productSelectHandle(list) {
				list = list.filter(item => {
					return !this.productList.find(row => {
						return row.product_id == item.product_id;
					});
				});
				this.productList = this.productList.concat(list);
			},
			
			deleteProduct(rowData){
				const index = this.productList.indexOf(rowData);
				this.productList.splice(index, 1);
			},
			
			submit(state) {
				this.$refs.form.submit({
					url: this.id ? '/couponInfo/edit' : '/couponInfo/add',
					
					rule: {
						coupon_name: '请填写优惠券名称',
						coupon_sales: [{
							type: 'function',
							fun: () => {
								return this.sales && (this.salesType == 1 || this.limit);
							},
							message: this.salesType == 1 ? '请填写优惠券金额' : '请填写优惠券门槛和金额'
						}],
						commodity_remark: '请填写使用条件简述',
						coupon_range: [{
							type: 'function',
							fun: () => {
								return this.commodityRange == 1 || (this.commodityRange == 2 && this.productList.length) || (this.commodityRange == 3 && (this.classify.length>0 || this.brand.length>0));
							},
							message: this.commodityRange == 2 ? '请选择指定商品' : '请选择指定条件'
						}]
					},
					
					dataFormatter: data => {
						this.id && (data.id = this.id);
						data.state = state;
						data.condition_amount = this.limit || 0;
						data.decrease_amount = this.sales;
						
						if (data.commodity_range == 2) {
							data.product_list = Array.from(this.productList, item => {
								return {
									product_id: item.product_id
								}
							});
						} else if (data.commodity_range == 3) {
							data.commodity_condition_json = JSON.stringify({
								brand_ids: this.brand.join(','),
								classify_ids: this.classify.join(',')
							});
						}
						
						return data;
					},
					
					success: () => {
						this.$message({
							type:'success',
							message: '保存成功'
						});
						this.navigateTo('/coupon');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.limit {
		.item {
			margin-right: 16px;
			
			label {
				margin-right: 8px;
			}
		}
	}
</style>